const sideBarTitles = [
  "SUMMARY",
  "PROJECTS",
  "EDUCATION",
  "EXPERIENCE",
  "SKILLS",
  "MILITARY SERVICE",
  "LANGUAGES"
];

export default sideBarTitles;
